import {
    Component
} from "@angular/core";
import {
    NavController,
    NavParams,
    ModalController
} from "ionic-angular";
import {
    APIServiceProvider
} from "./../../../common/services/api.service";
import {
    CustomerModalPage
} from "../../../modals/customer/customer.modal";
import {
    OrderdetailsModalPage
} from "../../../modals/orderdetails/orderdetails.modal";
import {
    OrderreceivedModalPage
} from "../../../modals/orderreceived/orderreceived.modal";
import {
    NotifyService
} from "../../../services/notify.service";

import {
    HelperServiceProvider
} from "./../../../common/services/helper.service";
import { PaymentInfoPage } from "../../../modals/payment-info/payment-info";

@Component({
    selector: "page-ordersdispatched",
    templateUrl: "ordersdispatched.html"
})
export class OrdersdispatchedPage {
    public ordersData: any = [];
    public ordersApiResponse: any;
    private apiUrl: any = "orders/all";
    public postParams: any = {
        order_status: 3,
        dispatched_to: localStorage.getItem("manager_user_id"),
        received_order: 0
    };

    public user_id: any = localStorage.getItem("user-id");
    public manager_user_id: any = localStorage.getItem("manager_user_id");

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public apiService: APIServiceProvider,
        public modalController: ModalController,
        public helperService: HelperServiceProvider,
        public notifyService: NotifyService
    ) {
        this.notifyService.orderReceived.subscribe(() => {
            this.getOrdersDispatched();
        });
    }
    ionViewWillEnter(){
        this.getOrdersDispatched();
      }
    // ionViewDidLoad() {
    //     this.getOrdersDispatched();
    // }

    doRefresh(refresh) {
        this.getOrdersDispatched(refresh);
    }

    doInfiniteScroll(infiniteScroll) {
        if (!this.ordersApiResponse.next_page_url ||
            this.ordersApiResponse.next_page_url === "" ||
            this.ordersApiResponse.next_page_url === null ||
            this.ordersApiResponse.next_page_url === "null"
        ) {
            infiniteScroll.complete();
            return;
        }
        this.apiService
            .post(
                this.apiUrl,
                this.postParams,
                this.ordersApiResponse.next_page_url
            )
            .subscribe(data => {
                this.ordersApiResponse = data["data"];
                this.ordersData = this.ordersData.concat(data["data"]["data"]);
                infiniteScroll.complete();
            });
    }

    getOrdersDispatched(refresh ? ) {
        this.apiService.post(this.apiUrl, this.postParams).subscribe(data => {
            this.ordersApiResponse = data["data"];
            this.ordersData = data["data"]["data"];
            if (refresh) {
                refresh.complete();
            }
        });
    }

    showCustomerModel(order_id) {
        let modalObject = this.modalController.create(CustomerModalPage, {
            order_id: order_id
        });

        modalObject.present();
    }

    showOrderDetailsModal(order_id) {
        this.getOrderDetails(order_id).then(data => {
            let modalObject = this.modalController.create(
                OrderdetailsModalPage, {
                    orderDetails: data
                }
            );

            modalObject.present();
        });
    }

    getOrderDetails(order_id) {
        return new Promise((resolve, reject) => {
            const params = {
                order_id
            };
            this.apiService
                .post("orders/get-order-details", params)
                .subscribe(result => {
                    resolve(result);
                });
        });
    }

    orderReceived(data) {
        let modalObject = this.modalController.create(OrderreceivedModalPage, {
            order: data
        });
        modalObject.present();
    }

    showOrderDetailsModal1(order) { 
        this.getOrderDetailsPayment(order?.order_payment_detail?.opportunity_id).then(data => {
          let modalObject = this.modalController.create(PaymentInfoPage, {
            orderDetails: order
          });
    
          modalObject.present();
        });
      } 
      getOrderDetailsPayment(order_id) {
        return new Promise((resolve, reject) => {
          const params = {
            order_id
          };
          this.apiService
            .get("order/finance/get-payment-history/"+order_id)
            .subscribe(result => {
              resolve(result);
            });
        });
      }
}


// WEBPACK FOOTER //
// ./src/pages/orders/ordersdispatched/ordersdispatched.ts